// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".userinfo-container[data-v-4614dcb5] {\n  padding: 0.052083rem;\n}\n[data-v-4614dcb5] .el-dialog {\n  margin-top: 0.052083rem !important;\n}", "",{"version":3,"sources":["D:/source/2000HuiTian/huitianadmin/<input css 29>"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;AAEA;EACE,kCAAkC;AACpC","file":"appoint.vue","sourcesContent":[".userinfo-container {\n  padding: 0.052083rem;\n}\n\n/deep/.el-dialog {\n  margin-top: 0.052083rem !important;\n}"]}]);
// Exports
module.exports = exports;
